<template>
  <v-main class="primary mt-4">
    <router-view />
    <v-overlay
      :value="overlay"
      :z-index="10"
      align="center"
      color="secondary"
      opacity="1"
    >
      <v-progress-circular
        indeterminate
        color="primary"
      />
      <div class="text-overline mt-4">
        Cargando información. Por favor, espere...
      </div>
    </v-overlay>
  </v-main>
</template>
<script>
import { mapActions } from 'vuex';

export default {
  name: 'IndexView',
  data() {
    return {
      overlay: false,
    };
  },
  async mounted() {
    this.overlay = true;
    try {
      await this.fetchEstatusDerivaciones();
      await this.fetchDerivacionesByArea(17);
      await this.fetchEvaluadores(17);
      await this.fetchSolicitudes();
      await this.fetchProgramacionesEvaluaciones();
      await this.fetchExpedientes();
      await this.fetchEstatusProgramacion();
      await this.fetchTipoSolicitud();
      await this.fetchMotivoEvaluacion();
      await this.fetchTipoExpediente();
      await this.fetchSexo();
      await this.fetchEstadoCivil();
      await this.fetchParentesco();
      await this.fetchPuestos();
      await this.fetchDependencias();
      await this.fetchRamas();
      await this.fetchAreas();
      await this.fetchMunicipios();
      await this.fetchEvaluacionesPsicologicas();
      await this.fetchSemaforoResultado();
    } catch (error) {
      console.log(error);
    }
    this.overlay = false;
  },

  methods: {
    ...mapActions('derivaciones', ['fetchDerivacionesByArea']),
    ...mapActions('evaluadores', ['fetchEvaluadores']),
    ...mapActions('evaluacionesPsicologicas', ['fetchEvaluacionesPsicologicas']),
    ...mapActions('programacionEvaluacion', ['fetchProgramacionesEvaluaciones']),
    ...mapActions('tipoSolicitud', ['fetchTipoSolicitud']),
    ...mapActions('estatusProgramacion', ['fetchEstatusProgramacion']),
    ...mapActions('motivoEvaluacion', ['fetchMotivoEvaluacion']),
    ...mapActions('tipoExpediente', ['fetchTipoExpediente']),
    ...mapActions('solicitudes', ['fetchSolicitudes']),
    ...mapActions('puesto', ['fetchPuestos']),
    ...mapActions('dependencia', ['fetchDependencias']),
    ...mapActions('rama', ['fetchRamas']),
    ...mapActions('areas', ['fetchAreas']),
    ...mapActions('municipio', ['fetchMunicipios']),
    ...mapActions('expediente', ['fetchExpedientes']),
    ...mapActions('sexo', ['fetchSexo']),
    ...mapActions('estadoCivil', ['fetchEstadoCivil']),
    ...mapActions('parentesco', ['fetchParentesco']),
    ...mapActions('semaforoResultado', ['fetchSemaforoResultado']),
    ...mapActions('estatusDerivaciones', ['fetchEstatusDerivaciones']),
  },
};
</script>
